import type { SVGProps } from 'react';
const SvgWbAuto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wb_auto_svg__a)">
      <path
        fill="currentColor"
        d="M6.85 12.65h2.3L8 9l-1.15 3.65ZM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22Zm-11.7 9-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9Z"
      />
    </g>
    <defs>
      <clipPath id="wb_auto_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWbAuto;
